import React from 'react'
import { Row, Col, Button, Image} from 'react-bootstrap';
import logo from '../assets/Logo.svg'

const HomeTexts = () => {
  return (
    <>
      <Row style={{}} className='text-black' data-aos="zoom-in-up">
                <Col xs={10} md={5} className="mx-4 my-5 d-flex justify-content-center align-items-center">
                    <Row className='text-center m-4 p-3 rounded-5 shadow-lg'style={{backgroundColor:"rgba(255, 255, 255, 0.8)"}}>
                        <h1 className="opacity-100 fw-semibold fst-italic"><Image src={logo} width={200}/></h1>
                        <h3 className="lh-lg text-danger">Prevenção contra incêndio</h3>
                        <h3 className="lh-base">Para seu B.O, somos a solução!</h3>
                    <div>
                        <Button className='my-3' href="https://api.whatsapp.com/send?phone=5511974111995&text=Olá Bruno! Acessei seu site e quero saber mais sobre seus serviços!">
                            Entre em contato
                        </Button>
                    </div>
                    </Row>
                </Col>
                <Col xs={12} md={1} style={{height:"3.5rem"}}></Col>
                <Col md={{span: 3, offset: 2}} className="px-3 mb-2">
                    <div className="d-flex justify-content-end align-items-end h-100">
                        <h5 className='text-end m-2 lh-lg p-4 rounded-5 text-bg-light opacity-75'>
                            Especialista em soluções para proteção contra incêndio, com suporte técnico, manutenção e instalação eficiente.
                        </h5>
                    </div>
                </Col>
            </Row>
    </>
  )
}

export default HomeTexts
